// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/closure-and-unserviceable-markings.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/closure-and-unserviceable-markings/closure-and-unserviceable-markings.js';

mount([g0]);
